export default "__VITE_ASSET__3d4a6bbd__"